<!-- Template -->

<template>
    <div>
        <a @click.prevent="openDialog()">Create New Support Request</a>
        <TicketDetailsDialog ref="newTicketDialog" />
        <NoActiveContractsSupportDialog ref="noActiveContractsDialog" />
    </div>
</template>

<!-- Script -->

<script>
    import TicketDetailsDialog from "@/components/Dialogs/TicketDetails";
    import NoActiveContractsSupportDialog from "@/components/Dialogs/NoActiveContractsSupportDialog";

    export default {
        name: "RaiseNewTicketButton",

        components: {
            TicketDetailsDialog,
            NoActiveContractsSupportDialog
        },

        props: ["system", "section", "hospital"],

        data() {
            return {
                canRaiseTicket: false
            };
        },

        computed: {
            ticketDetailsDialog() {
                return this.$refs.newTicketDialog;
            },
            noActiveContractsDialog() {
                return this.$refs.noActiveContractsDialog;
            }
        },

        methods: {
            openDialog() {
                var sites = this.$store.getters["hospital/sites"];
                var self = this;
                var selectedSite = sites.filter(function(el) {
                    return el.id == self.system.siteId;
                });

                this.canRaiseTicket = selectedSite[0].canRaiseTicket && this.system.trainingStatus == 'Complete';

                if (this.canRaiseTicket) {
                    //this.noActiveContractsDialog.close();
                    this.ticketDetailsDialog.show(this.system);
                } else {
                    //this.ticketDetailsDialog.close();
                    this.noActiveContractsDialog.show();
                }
            }
        }
    };
</script>

